// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UWmI","toggleWrap":"styles_toggleWrap__3YVLz","content":"styles_content__1jefo","selectAreaCode":"styles_selectAreaCode__3R4YQ"};